import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/settings/appearance")({
  head: () => ({ meta: [{ title: "Appearance | Settings" }] }),
  component: lazyRouteComponent(() => import("@/pages-lazy/admin-settings-appearance")),
});
